import React from "react";

import styled from "styled-components";
import CV from "../../styles/variables";

interface IProps {
  color: string;
}

const Button: React.FunctionComponent<IProps> = ({ color }) => {
  return <button style={{ color }}>Click Me</button>;
};

export const LightButton = styled.button`
  color: white;
  background-color: ${CV.colorP2};
  font-size: 12px;
  padding: 8px;
  border-radius: 4px;
  height: 32px;
  line-height: 1;
  transition: all 0.3s ease-in-out;
  :hover {
    background-color: ${CV.colorP3};
  }
`;

export default Button;
